var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import ZXing_cpp from "./zxing_reader";
var Eevents;

(function (Eevents) {
  Eevents[Eevents["found"] = 0] = "found";
  Eevents[Eevents["error"] = 1] = "error";
})(Eevents || (Eevents = {}));

var Result =
/** @class */
function () {
  function Result(result) {
    if (result) {
      this.error = result.error ? result.error : '';
      this.format = result.format ? result.format : '';
      this.position = result.position ? result.position : {
        bottomRight: {
          x: 0,
          y: 0
        },
        bottomLeft: {
          x: 0,
          y: 0
        },
        topRight: {
          x: 0,
          y: 0
        },
        topLeft: {
          x: 0,
          y: 0
        }
      };
      this.text = result.text ? result.text : '';
      this.profile_info = result.profile_info ? result.profile_info : '';
    } else {
      this.error = '';
      this.format = '';
      this.position = {
        bottomRight: {
          x: 0,
          y: 0
        },
        bottomLeft: {
          x: 0,
          y: 0
        },
        topRight: {
          x: 0,
          y: 0
        },
        topLeft: {
          x: 0,
          y: 0
        }
      };
      this.text = '';
      this.profile_info = '';
    }
  }

  return Result;
}();

export { Result };

var ZXing =
/** @class */
function () {
  function ZXing() {
    this._callbacks = {};

    this._getReader();
  }

  ZXing.prototype.on = function (event, callback) {
    switch (event) {
      case "found":
        this._callbacks.found = callback;
        break;

      case "error":
        this._callbacks.error = callback;
        break;
    }
  };

  ZXing.prototype._getReader = function () {
    return __awaiter(this, void 0, void 0, function () {
      var reader_proxy, _a, e_1;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            reader_proxy = this._reader;
            if (!!reader_proxy) return [3
            /*break*/
            , 4];
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            _a = this;
            return [4
            /*yield*/
            , ZXing_cpp()];

          case 2:
            _a._reader = _b.sent();
            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _b.sent();

            if (this._callbacks.error) {
              this._callbacks.error(new Error("Reader could not be initialised"));
            }

            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ZXing.prototype._getFileData = function (file) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var file_reader = new FileReader();

      file_reader.onloadend = function (e) {
        return __awaiter(_this, void 0, void 0, function () {
          var file_data;
          return __generator(this, function (_a) {
            if (e.target && e.target.result && typeof e.target.result !== 'string') {
              file_data = new Uint8Array(e.target.result);
              resolve(file_data);
            } else {
              reject('File failed to load.');
            }

            return [2
            /*return*/
            ];
          });
        });
      };

      file_reader.readAsArrayBuffer(file);
    });
  };

  return ZXing;
}();

export { ZXing };